export function isSiteSection(v) {
    return !!(v &&
        (v.hasOwnProperty("general") ||
            v.hasOwnProperty("alert") ||
            v.hasOwnProperty("navigation") ||
            v.hasOwnProperty("design") ||
            v.hasOwnProperty("social") ||
            v.hasOwnProperty("contact") ||
            v.hasOwnProperty("partners") ||
            v.hasOwnProperty("ads") ||
            v.hasOwnProperty("analytics")));
}
//# sourceMappingURL=is-site-section.js.map